import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import "./AccountingTable.scss";
import Close from "../../images/close-light.svg";
import AccountingModalTable from "./AccountingModalTable";

function AccountingDetailModal({ open, handleClose, selectedData }) {
  const [openAccordion, setOpenAccordion] = useState(null);

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="accountingdetailmodal-container"
      >
        <div className="centered-content">
          <div className="d-flex justify-content-between">
            <div className="modal-title">Balance Details</div>
            <img className="pointer" src={Close} onClick={handleClose} loading="lazy" />
          </div>
          <div className="accounting-modal-table">
            <AccountingModalTable selectedData={selectedData} />
          </div>
          {/* <div className="bottom-modal-element">
            <div className="d-flex gap-3 align-items-center">
              <span>Download Excel (CSV) Report</span>
            </div>
          </div> */}
        </div>
      </Modal>
    </div>
  );
}

export default AccountingDetailModal;
